<template>
  <div class="pdfViewerContainer">
    <div>
      <div class="container">
        <div class="row">
          <div class="col-4 py-1 pr-0">
            <span>
              <input
                v-model.number="currentPage"
                type="number"
                class="toolbarField"
                value="1"
                min="1"
                :max="totalPages"
                tabindex="0"
                data-l10n-id="pdfjs-page-input"
                autocomplete="off"
                @change="goToPage(currentPage)"
              />
            </span>
            <span class="toolbarLabel">de {{ totalPages }}</span>
            
            <!-- Botón para página anterior -->
            <button class="btn btn-sm p-0" title="Página anterior" @click="goToPage(currentPage - 1)">
              <svg width="24" height="24" viewBox="0 0 24 24" style="--sx: 1; --sy: 1; --r: 0deg;"><path :d="extractPathData(icons.mdiSkipPrevious)" /></svg>
            </button>
            
            <!-- Botón para página siguiente -->
            <button class="btn btn-sm p-0" title="Página siguiente" @click="goToPage(currentPage + 1)">
              <svg width="24" height="24" viewBox="0 0 24 24" style="--sx: 1; --sy: 1; --r: 0deg;"><path :d="extractPathData(icons.mdiSkipNext)" /></svg>
            </button>
          </div>
          <div class="col-4 py-1 px-0 text-center">
            
            <!-- Controles de zoom -->
            <button class="btn btn-sm p-0" title="Acercar" @click="zoomOut">
              <svg width="24" height="24" viewBox="0 0 24 24" style="--sx: 1; --sy: 1; --r: 0deg;"><path :d="extractPathData(icons.mdiMagnifyMinusOutline)" /></svg>
            </button>
            <button class="btn btn-sm p-0" title="Alejar" @click="zoomIn">
              <svg width="24" height="24" viewBox="0 0 24 24" style="--sx: 1; --sy: 1; --r: 0deg;"><path :d="extractPathData(icons.mdiMagnifyPlusOutline)" /></svg>
            </button>
            <!-- Controles de rotación -->
            <button class="btn btn-sm p-0" title="Girar a la izquierda" @click="rotateLeft">
              <svg width="24" height="24" viewBox="0 0 24 24" style="--sx: 1; --sy: 1; --r: 0deg;"><path :d="extractPathData(icons.mdiRotateLeft)" /></svg>
            </button>
            <button class="btn btn-sm p-0" title="Girar a la derecha" @click="rotateRight">
              <svg width="24" height="24" viewBox="0 0 24 24" style="--sx: 1; --sy: 1; --r: 0deg;"><path :d="extractPathData(icons.mdiRotateRight)" /></svg>
            </button>
          </div>
          <div class="col-4 py-1 pl-0 text-right">
            <!-- Botón de descarga -->
            <button class="btn btn-sm p-0" title="Descargar" @click="downloadPDF">
              <svg width="24" height="24" viewBox="0 0 24 24" style="--sx: 1; --sy: 1; --r: 0deg;"><path :d="extractPathData(icons.mdiDownload)" /></svg>
            </button>
            <!-- Botón de descarga -->
            <button class="btn btn-sm p-0" title="Imprimir" @click="printPDF">
              <svg width="24" height="24" viewBox="0 0 24 24" style="--sx: 1; --sy: 1; --r: 0deg;"><path :d="extractPathData(icons.mdiPrinterOutline)" /></svg>
            </button>
          </div>
        </div>
      </div>
      <!-- Contenedor del visor de PDF -->
      <div id="viewerContainer" ref="viewerContainer">
        <div id="viewer" ref="viewer" class="pdfViewer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDocument, GlobalWorkerOptions, LinkTarget } from "pdfjs-dist/legacy/build/pdf";
import { PDFViewer, PDFLinkService, EventBus } from "pdfjs-dist/legacy/web/pdf_viewer";
/* import {  PDFWorker } from "pdfjs-dist/legacy/build/pdf";
const myWorker = new Worker('/js/pdfjs/pdf.worker.min.mjs', { type: 'module' });
const worker = new PDFWorker({ port: myWorker }); */
//GlobalWorkerOptions.workerPort = new PDFWorker()

GlobalWorkerOptions.workerSrc = new URL("/js/pdfjs/pdf.worker.min.js", window.location.origin).toString();
import mdiPrinterOutline from '@iconify-icons/mdi/printer-outline';
import mdiDownload from '@iconify-icons/mdi/download';
import mdiRotateLeft from '@iconify-icons/mdi/rotate-left';
import mdiRotateRight from '@iconify-icons/mdi/rotate-right';
import mdiMagnifyPlusOutline from '@iconify-icons/mdi/magnify-plus-outline';
import mdiMagnifyMinusOutline from '@iconify-icons/mdi/magnify-minus-outline';
import mdiSkipPrevious from '@iconify-icons/mdi/skip-previous';
import mdiSkipNext from '@iconify-icons/mdi/skip-next';


export default {
  name       : "PdfViewerComponent",
  props : {
    file : {
      type    : Number,
      default : null
    },
    files : {
      type    : Array,
      default : ()=>[]
    },
    // Prop para el texto dinámico de la marca de agua
    watermarkText : {
      type    : String,
      default : ""
    }
  },
  data() {
    return {
      icons           : {mdiPrinterOutline, mdiDownload, mdiRotateLeft, mdiRotateRight, mdiMagnifyPlusOutline, mdiMagnifyMinusOutline, mdiSkipPrevious, mdiSkipNext},
      pdfDocProxy     : null,     // Referencia al documento PDF cargado
      totalPages      : 0,         // Total de páginas del PDF
      currentPage     : 1,        // Página actual
      currentScale    : 1.0,     // Escala actual (zoom)
      scaleJump       : 0.15,        // Incremento de escala al hacer zoom
      currentRotation : 0,    // Rotación actual (en grados)
      viewer          : null,          // Instancia de PDFViewer
      linkService     : null,     // Instancia de PDFLinkService
      eventBus        : null         // Instancia de EventBus (para manejo interno de eventos)
    };
  },
  computed : {
    // Construye la URL del PDF a partir del id del archivo
    pdfSource() {
      const url = "tramite/documento/print/archivo/" + this.file;
      return "/" + url;
    },
    nombreArchivo() {
      const file = this.files.find((file) => file.id === this.file);
      return file ? file.id_documento+' '+file.file_name : "documento.pdf";
    },
    // Genera dinámicamente un data URL con un SVG para la marca de agua en tono rojo (no invasivo)
    watermarkDataUrl() {
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="300" height="200">
          <text x="30%" y="90%" dominant-baseline="middle" text-anchor="middle"
                fill="rgba(255,0,0,0.15)" font-size="24" transform="rotate(-30)">
            ${this.watermarkText}
          </text>
        </svg>
      `;
      return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
    }
  },
  watch : {
    file(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.reloadPdf();
      }
    }
  },
  mounted() {
    this.initViewer();
    
    window.addEventListener("keydown", this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  methods : {
    extractPathData(icon) {
      const match = icon.body.match(/<path[^>]*d="([^"]+)"/);
      return match ? match[1] : null;
    },
    handleCopy() {
      console.log("📋 Interceptando clic derecho > copiar");

      const selection = window.getSelection();
      if (!selection || selection.isCollapsed) return;

      const rawText = selection.toString();

      const cleanedText = rawText
        .replace(/-\s*\n\s*/g, '- ')                  // ✅ une líneas cortadas por guiones
        .replace(/([^\n])\n(?=\p{Ll})/gu, "$1 ")      // ✅ une si la siguiente línea comienza en minúscula
        .replace(/\n{2,}/g, "\n")                     // ✅ mantiene saltos dobles como separadores
        .replace(/[ \t]{2,}/g, " ")                   // ✅ limpia espacios múltiples
        .trim();

      if (!cleanedText) return;

      // Creamos un textarea oculto
      const textarea = document.createElement("textarea");
      textarea.value = cleanedText;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      textarea.style.top = `${window.scrollY}px`; // asegura visibilidad para Safari
      document.body.appendChild(textarea);

      textarea.select();

      // No usamos preventDefault aquí
      setTimeout(() => {
        document.body.removeChild(textarea);
        console.log("✅ Texto limpio copiado con clic derecho:", cleanedText);
      }, 50);
    },
    reloadPdf() {
      // Primero, destruye la instancia actual para evitar conflictos
      this.destroyViewer();
      // Reinicializa las variables relevantes (por ejemplo, resetea la página actual)
      this.currentPage = 1;
      // Vuelve a inicializar el visor con el nuevo archivo
      this.initViewer();
    },
    destroyViewer() {
      // Si el eventBus está configurado, removemos los listeners
      if (this.eventBus) {
        // Si la API de EventBus tiene off(), se utiliza para remover listeners
        if (typeof this.eventBus.off === "function") {
          this.eventBus.off("pagesinit");
          this.eventBus.off("pagerendered");
        }
        this.eventBus = null;
      }
      // Limpia el contenedor del visor para eliminar cualquier elemento renderizado previamente.
      if (this.$refs.viewerContainer) {
        this.$refs.viewerContainer.innerHTML = '<div id="viewer" ref="viewer" class="pdfViewer"></div>';
      }
      // Se eliminan las referencias a las instancias del visor, linkService y documento
      this.viewer = null;
      this.linkService = null;
      this.pdfDocProxy = null;
    },
    initViewer() {
      // Instanciar PDFLinkService y EventBus
      this.linkService = new PDFLinkService();
      this.linkService.externalLinkTarget = LinkTarget ? LinkTarget.BLANK : 2;
      this.eventBus = new EventBus();
      
      // Crear la instancia de PDFViewer utilizando el contenedor (viewerContainer)
      this.viewer = new PDFViewer({
        container           : this.$refs.viewerContainer,
        eventBus            : this.eventBus,
        linkService         : this.linkService,
        //supportsPinchToZoom : true,
        //enableHWA           : true,
        textLayerMode       : 1,          // Habilita la capa de texto (para selección y resaltado)
        annotationLayerMode : 1     // Habilita la capa de anotaciones (hipervínculos)
      });
      this.linkService.setViewer(this.viewer);

      // Cargar el documento PDF
      const loadingTask = getDocument({
        url     : this.pdfSource,
        wasmUrl : '/js/pdfjs/',
      });
      loadingTask.promise
        .then((pdfDoc) => {
          this.pdfDocProxy = pdfDoc;
          this.totalPages = pdfDoc.numPages;
          this.linkService.setDocument(pdfDoc);
          this.viewer.setDocument(pdfDoc);
          // Espera a que el visor dispare el evento 'pagesinit'
          this.eventBus.on("pagesinit", () => {
            // Ahora el visor está listo, se pueden asignar la escala y la rotación.
            this.viewer.currentScaleValue = this.currentScale;
            this.viewer.pagesRotation = this.currentRotation;
            //console.log("📄 Evento pagesinit disparado: visor completamente cargado");
            const viewerContainer = this.$refs.viewerContainer || this.$el.querySelector('.pdfViewerContainer');
            if (viewerContainer) {
              viewerContainer.addEventListener("copy", this.handleCopy, true);
              //console.log("✅ Evento copy vinculado correctamente");
            }
          });
        })
        .catch((error) => {
          console.error("Error al cargar el PDF:", error);
        });
      this.initEvents()
    },
    initEvents(){
      
      this.eventBus.on("pagechanging", (evt) => {
        this.currentPage = Number(evt.pageNumber);
      });
      // Inyectar la marca de agua en cada página cuando se renderice.
      this.eventBus.on("pagerendered", (e) => {
        if (e && e.source && e.source.div) {
        // Elimina un overlay anterior, si existiese.
          const existing = e.source.div.querySelector('.watermarkOverlay');
          if (existing) existing.remove();

          // Crear un overlay para la marca de agua.
          const watermarkDiv = document.createElement("div");
          watermarkDiv.className = "watermarkOverlay";

          // Agregar estilos usando setProperty.
          watermarkDiv.style.setProperty("position", "absolute");
          watermarkDiv.style.setProperty("top", "0");
          watermarkDiv.style.setProperty("left", "0");
          watermarkDiv.style.setProperty("width", "100%");
          watermarkDiv.style.setProperty("height", "100%");
          watermarkDiv.style.setProperty("pointer-events", "none");
          watermarkDiv.style.setProperty("background-image", `url('${this.watermarkDataUrl}')`);
          watermarkDiv.style.setProperty("background-repeat", "repeat");
          watermarkDiv.style.setProperty("z-index", "10");

          // Inyectar el overlay en el contenedor de la página.
          e.source.div.appendChild(watermarkDiv);
        }
      });
    },
    goToPage(pageNum) {
      const pageNumber = Number(pageNum);
      if (pageNumber < 1 || pageNumber > this.totalPages) return;
      this.currentPage = pageNumber;
      this.viewer.scrollPageIntoView({ pageNumber });
    },
    zoomIn() {
      this.currentScale = parseFloat((this.currentScale + this.scaleJump).toFixed(1));
      this.viewer.currentScaleValue = this.currentScale;
    },
    zoomOut() {
      this.currentScale = parseFloat((this.currentScale - this.scaleJump).toFixed(1));
      if (this.currentScale < this.scaleJump) this.currentScale = this.scaleJump;
      this.viewer.currentScaleValue = this.currentScale;
    },
    rotateLeft() {
      this.currentRotation = (this.currentRotation - 90) % 360;
      this.viewer.pagesRotation = this.currentRotation;
    },
    rotateRight() {
      this.currentRotation = (this.currentRotation + 90) % 360;
      this.viewer.pagesRotation = this.currentRotation;
    },
    handleKeyDown(e) {
    // Verifica si se presionó Ctrl (o Cmd en macOS) y la tecla "p"
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'p') {
        e.preventDefault();
        // Llama a tu método de impresión personalizado
        this.printPDF();
      }
      // Para guardar: Ctrl + S o Cmd + S
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
        e.preventDefault();
        this.downloadPDF();
      }
    },
    async downloadPDF() {
      try {
        // Obtenemos el PDF como blob usando fetch
        const response = await fetch(this.pdfSource, { method: "GET" });
        if (!response.ok) throw new Error("Error al descargar el PDF");
        const blob = await response.blob();
        // Creamos un URL temporal para el blob
        const url = window.URL.createObjectURL(blob);
        // Creamos un enlace oculto y lo activamos para iniciar la descarga
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        // Opcional: asigna un nombre de archivo predeterminado
        a.download = this.nombreArchivo;
        document.body.appendChild(a);
        a.click();
        // Limpieza: remover el enlace y revocar el URL
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error al descargar el PDF:", error);
      }
    },
    async printPDF() {
      try {
        // Obtener el PDF como blob
        const response = await fetch(this.pdfSource, { method: "GET" });
        if (!response.ok) throw new Error("Error al obtener el PDF para imprimir");
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
    
        // Crear un iframe oculto para imprimir
        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";
        iframe.src = url;
        document.body.appendChild(iframe);

        // Función de limpieza que elimina el iframe y revoca el URL
        const cleanup = () => {
          if (iframe.parentNode) {
            document.body.removeChild(iframe);
          }
          window.URL.revokeObjectURL(url);
          window.removeEventListener("afterprint", cleanup);
          // También eliminamos el handler del iframe
          iframe.contentWindow.onafterprint = null;
        };

        // Agregar listener para el evento afterprint en el objeto window.
        // En algunos navegadores el evento se dispara en el objeto global.
        window.addEventListener("afterprint", cleanup);

        // Esperar a que el iframe cargue el PDF
        iframe.onload = () => {
          // Asegurarse de que el iframe tenga el foco y llamar a print
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
      
          // También asignar el handler onafterprint en el iframe (por compatibilidad)
          iframe.contentWindow.onafterprint = cleanup;
        };
      } catch (error) {
        console.error("Error al imprimir el PDF:", error);
      }
    }

  }
};
</script>

<style scoped>

path {
  fill: #ffffff;
}
/* Contenedor del visor de PDF */
#viewerContainer {
  position: absolute;
  top: 40px; /* Altura de la barra de herramientas */
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
  background: #808080;
}
.pdfViewerContainer{
  background-color: #3b3b3b;
    color: white;
}

.pdfViewerContainer  input{
  background-color: #3b3b3b;
  border: solid 1px white;
  color: white;
  text-align: center;
}
/* Área donde se renderizan las páginas */
#viewerContainer {
  margin: 0 auto;
  background: #6b6b6b;
  /* PDFViewer inyecta su propio estilo en los elementos internos */
}
#viewer {
  --page-border: 1px solid #ccc;
  --page-margin: 8px auto 8px;
  
  /* Escala el contenido al 95% */
  /* transform: scale(0.95); */
}
</style>
